import {
    AddSquare,
    ArrowSwapHorizontal,
    Maximize4,
    Sort,
    type IconComponent,
} from '@/components/icons';
import { APP_FONT } from '@/constants';
import type { AIPanelPosition } from './types';
import type { AIImprovementIntent } from '@/api/ai';
export type AIPreset = {
    key: AIImprovementIntent;
    label: string;
    icon: IconComponent;
};

export const AI_PRESETS: AIPreset[] = [
    {
        key: 'rewrite',
        label: 'Reescrever',
        icon: ArrowSwapHorizontal,
    },
    {
        key: 'summarize',
        label: 'Resumir',
        icon: Sort,
    },
    {
        key: 'detail',
        label: 'Detalhar',
        icon: AddSquare,
    },
    {
        key: 'expand',
        label: 'Expandir',
        icon: Maximize4,
    },
];

export const MOBILE_BREAKPOINT = 768;
export const PANEL_VIEWPORT_MARGIN = 12;
export const PANEL_TRIGGER_GAP = 10;
export const PANEL_FALLBACK_WIDTH = 420;
export const PANEL_FALLBACK_HEIGHT = 360;

export const PANEL_CLOSE_ANIMATION_MS = 130;

export const AI_UI_FONT_STYLE = {
    fontFamily: APP_FONT,
};

export const DEFAULT_AI_PANEL_POSITION: AIPanelPosition = {
    top: 0,
    left: 0,
    placement: 'bottom',
    isMobile: false,
};

// The toolbar's portaled overlays land in document.body at the shared z-50, which
// is below the floating section editor (z-[70]) that hosts them — they'd render
// behind the opaque panel. Sit above it, but below the AI panel (z-[80]).
export const EDITOR_OVERLAY_Z_CLASSNAME = 'z-[75]';

export const EDITOR_PROSE_CLASSNAMES =
    'prose prose-sm max-w-none focus:outline-none min-h-[100px] px-3 py-2 prose-p:my-3 prose-headings:my-2 prose-ul:list-disc prose-ol:list-decimal prose-ul:pl-6 prose-ol:pl-6';

// Sizes are stored in pt, the unit Word and Google Docs show and the one the
// DOCX export consumes (half-points = pt * 2).
//
// 10.5pt is the document default: it mirrors the api theme's `paragraphSize: 21`
// (see `styles/defaultTheme.ts`), which in turn matches the `prose-sm` body text
// the editor and the read view render at. Picking it clears the mark instead of
// writing a span, so untouched text keeps following the theme.
export const DEFAULT_FONT_SIZE_PT = 10.5;

export const FONT_SIZE_OPTIONS = [8, 9, 10, DEFAULT_FONT_SIZE_PT, 11, 12, 14, 16, 18, 24, 30, 36];

export const formatFontSizePt = (size: number) => size.toString().replace('.', ',');
